export const ColumnHighlight = (
	<g transform="translate(0 111)">
		<path
			d="M45.851 51.7403C46.1991 52.1264 37.5584 62.5931 32.8869 65.5867C33.2869 67.6696 32.2938 70.7258 30.1281 72.6693C31.0476 82.1743 38.4673 68.6973 40.7035 64.4331C37.6491 65.5887 43.8988 61.0488 44.0992 59.5144C43.6673 60.0082 52.2027 50.0358 47.9367 50.697C48.0177 50.1863 45.1567 51.5259 45.8491 51.7301L45.851 51.7403Z"
			fill="#101214"
		/>
		<path
			d="M16.1279 39.4332C14.3771 41.7816 11.7702 42.5246 8.73204 42.6129C2.35221 50.3699 19.0068 45.3171 23.028 44.0392C23.028 44.0392 30.1376 41.9468 29.5669 42.541C30.8121 43.1552 42.4358 42.187 39.0269 38.7542C37.0509 38.7228 33.6103 40.2264 32.6329 39.0867C29.8602 37.1014 20.6744 40.5616 16.1197 39.4453L16.1279 39.4332Z"
			fill="#101214"
		/>
		<path
			d="M19.0264 3.89086C13.4167 6.99094 24.8454 12.6867 28.1617 16.0215C28.1617 16.0215 31.4108 19.6641 32.9233 20.0795C32.4526 19.5483 44.7158 31.7839 41.0433 22.755C40.8191 22.6295 36.5803 18.3868 36.5803 18.3868C32.7046 11.2616 25.4345 6.75824 19.0163 3.89282L19.0264 3.89086Z"
			fill="#101214"
		/>
	</g>
);
